module.exports = __webpack_public_path__ + "static/media/华安app02.c00459f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/华安app02.mp4
// module id = gYsU
// module chunks = 3